import { useSessionInfo } from '@/contexts/AuthContext/hooks/sessionInfo'


import { api } from '@/utils/api';
import { useMemo } from 'react';
export function useCreatorInfo() {
  const {
    isSignIn,
    isAnonymousUser,
    userId: sessionUserId,
    sessionLoading,
  } = useSessionInfo()

  const {
    data,
    isInitialLoading,
    refetch,
    isFetched,
    status,
    error,
    isRefetching,
    isLoading,
    remove,
  } = api.creator.getCreator.useQuery(undefined, {
    enabled: isSignIn,
    // enabled: false,
    cacheTime: 200,
  })

  const userInfo = useMemo(() => {
    return (
      data?.user || {
        name: '',
        firstName: '',
        lastName: '',
        image: '',
      }
    )
  }, [data])

  const displayName = useMemo(() => {
    if (!isSignIn) {
      return ''
    }
    return data?.displayName || ''
  }, [data?.displayName, isSignIn])

  const sign = useMemo(() => {
    return data?.sign || ''
  }, [data])

  return {
    data,
    refetch,
    isRefetching,
    isInitialLoading,
    isLoading,
    userInfo,
    displayName,
    sign,
    isFetched,
    remove,
  }
}

export type ICreatorInfo = ReturnType<typeof useCreatorInfo>
